import {
  ILabel,
  INode,
  IRenderContext,
  LabelStyleBase,
  Size,
  Rect,
} from '@ardoq/yfiles';
import { wrapString } from 'tabview/blocks/misc/string';
import { MODERNIZED_BLOCK_DIAGRAM_LABEL_MAX_LINES as MAX_LINES } from 'yfilesExtensions/styles/modernized/consts';
import { GraphItem } from '@ardoq/graph';
import {
  measureNodeLabel,
  MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT,
} from '@ardoq/graph-labeling';
import { MODERNIZED_BLOCK_DIAGRAM_LEAF_NODE_LABEL_WIDTH as LABEL_WIDTH } from './consts';
import { collapsedComponentGroupLabelTop } from './leafNodeLabel/collapsedComponentGroupLabelTop';
import { CanvasLabelVisual } from '../labels/CanvasLabelVisual';

class CollapsedComponentGroupLabelStyle extends LabelStyleBase {
  static Instance = new CollapsedComponentGroupLabelStyle();
  private constructor() {
    super();
  }

  protected override createVisual(AT_TARGET: IRenderContext, label: ILabel) {
    const {
      owner,
      text,
      layout: {
        center: { x: centerX },
      },
    } = label;
    if (!(owner instanceof INode)) {
      return null;
    }
    const { tag } = owner;
    const graphItem = tag as GraphItem;
    const { isTransparentized } = graphItem;
    const x = centerX - LABEL_WIDTH / 2;
    const y = collapsedComponentGroupLabelTop(owner);
    const wrappedLabel = wrapString(
      text,
      LABEL_WIDTH,
      measureNodeLabel,
      MAX_LINES
    );
    const height = wrappedLabel.length * LINE_HEIGHT;
    return new CanvasLabelVisual(
      new Rect(x, y, LABEL_WIDTH, height),
      null,
      wrappedLabel,
      isTransparentized ? 0.32 : 1
    );
  }

  protected override getPreferredSize(_label: ILabel): Size {
    return Size.ZERO;
  }
}
export { CollapsedComponentGroupLabelStyle };
